module.exports = __webpack_public_path__ + "img/notifications_off.4967f15f.svg";